import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';

import Box from '@mui/material/Box';
import { CHILDREN_PROP_TYPES } from 'propTypes';
import { baseCoverSx } from 'styles/sx/coverSx';

const StyledBox = styled(Box)(({ theme, backgroundColor }) => ({
  backgroundColor: backgroundColor || theme.palette.background.secondary,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  ...baseCoverSx
}));

function DarkCover({ children, dataTestId, ...rest }) {
  const { background } = rest;

  return (
    <StyledBox backgroundColor={background} data-testid={dataTestId}>
      {children}
    </StyledBox>
  );
}

DarkCover.propTypes = {
  children: CHILDREN_PROP_TYPES,
  dataTestId: PropTypes.string
};

export default DarkCover;
